import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { GasButtonModule } from '../../forms/gas-button/gas-button.module';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';
import { GasPanelComponent } from './gas-panel.component';

const COMPONENTS = [
  GasPanelComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
    GasButtonModule,
    GasIconsModule,
  ],
})
export class GasPanelModule { }
